export class GeomConstants {
}
GeomConstants.distanceEpsilonPrecision = 6;
GeomConstants.mult = Math.pow(10, 6);
GeomConstants.defaultLeafBoxesOffset = 0.5;
GeomConstants.lineSegmentThreshold = 0.05;
GeomConstants.intersectionEpsilon = 0.0001;
GeomConstants.distanceEpsilon = Math.pow(10, -GeomConstants.distanceEpsilonPrecision);
GeomConstants.squareOfDistanceEpsilon = Math.pow(10, -GeomConstants.distanceEpsilonPrecision * 2);
GeomConstants.tolerance = 1.0e-8;
//# sourceMappingURL=geomConstants.js.map